import { AfterViewInit, Component, ElementRef, inject, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EventEmitter } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NgIf, NgStyle } from '@angular/common';
import { FormLoginComponent } from '@shared/components/login/form-login/form-login.component';
@Component({
  standalone: true,
  selector: 'app-recaptcha',
  templateUrl: './recaptcha.component.html',
  styleUrls: ['./recaptcha.component.scss'],
  imports: [
    NgIf,
    NgStyle
  ]
})
export class RecaptchaComponent implements OnInit, AfterViewInit {
  @Input()
  public recaptcha: any;
  @Input()
  public isDialog: Boolean;
  @Input()
  public form: FormGroup;
  @Input()
  private dialogRef: MatDialogRef<any>;
  @Output()
  public sendTokenEvent = new EventEmitter();
  @Output()
  public sendError = new EventEmitter();
  @Output()
  public expiredToken = new EventEmitter();

  @ViewChild('contentCaptcha')
  container: ElementRef;

  private count: number = 0;
  public error: Boolean = false;
  private renderer = inject(Renderer2);

  ngOnInit(): void {
    if (this.dialogRef instanceof MatDialogRef  && this.recaptcha.active && this.recaptcha.type == 'normal') {
      this.dialogRef.updateSize('500px', '427px');
    }
  }

  ngAfterViewInit() {
    const widget = this.createElement();
    const baseOptions = {
      sitekey: this.recaptcha.token,
      'expired-callback': () => this.expired(),
      'error-callback': () => this.errored([]),
      'callback': (e: string) => this.resolved(e)
    };
    window['grecaptcha'].render(widget, baseOptions);
  }

  createElement() {
    const widgets = document.getElementById("widgets");
    const widget = document.createElement('div');
    widgets.appendChild(widget);
    widget.id = `widget-${this.count}`;
    this.count++;
    return widget;
  }

  public async executeRecaptchaInvisible(action: String): Promise<void> {
    if (!action) {
      action = '';
    }
    return new Promise((resolve) => {
      window['grecaptcha'].execute();
      setTimeout(() => {
        resolve();
       }, 500)
    })
  }

  expired() {
    this.expiredToken.emit();
  }

  resolved(token: string) {
    this.sendTokenEvent.emit(token);
  }

  errored(event: any) {
    this.error = true;
    this.dialogRef.updateSize('500px', '350px');
    this.renderer.addClass(this.container.nativeElement, 'hidden');
    this.sendError.emit(event);
  }

  reset() {
    window['grecaptcha'].reset();
  }
}
